import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
//import { DatePipe } from '@angular/common';

@Component({
  selector: 'complaints-type-form',
  templateUrl: './complaints-type-form.component.html',
  styleUrls: ['./complaints-type-form.component.css']
})
export class ComplaintsTypeFormComponent implements OnInit {
  title="Add ComplaintType";
  data : any = {};
  formInvalid : boolean = false;
  c : any = {};

  cmplnt_id : number;
  mode : string;

  
  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    ) 
  { 

  }

  ngOnInit() {
    this.route.params.subscribe(params => {      
      this.cmplnt_id = params['cmplnt_id'];  
      this.mode =  params['mode'];   
        
        if(this.cmplnt_id > 0){
          this.GetComplaintTypeById(this.cmplnt_id)
        }    
    });

    if(this.mode=='view'){
      this.title = "View Complaint Type ";
    }
    else if(this.mode=='edit'){
      this.title = "Edit Complaint Type ";
    }  
  }

  SaveComplaintType(ComplaintType: NgForm){ 
    
    if(ComplaintType.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     

    else{                                     
            this.data = this.UserService.PostComplaintType(ComplaintType.value);    
            this.data.subscribe(
            (response) => {
              ComplaintType.reset();
              ComplaintType.resetForm();
              ComplaintType.form.markAsPristine();
              ComplaintType.form.markAsUntouched();        
              swal('Success!', 'ComplaintType Added Successfully .', 'success');
              this.router.navigate(['/home/ctype']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }

  GetComplaintTypeById(cmplnt_id){
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.UserService.GetComplaintTypeById(cmplnt_id);
        this.data.subscribe(
          (response: any) => {
            this.c = response;        
                          
            document.getElementById('loader-spinner').style.display = "none";
          },(error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401 || error.status == 500) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
  }
  UpdateComplaintType(ComplaintType: NgForm) {  
    this.data = this.UserService.UpdateComplaintType(ComplaintType.value,this.cmplnt_id);
   this.data.subscribe(
     (response) => {
      ComplaintType.reset();
      ComplaintType.resetForm();
      ComplaintType.form.markAsPristine();
      ComplaintType.form.markAsUntouched();           
                   
       swal('Success!', 'ComplaintType updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/ctype']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401|| error.status == 500) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){
//this.router.navigate(['/home/district']) ; 
this.c.cmplnt_code='';
this.c.cmplnt_name='';
}




  

}




// WEBPACK FOOTER //
// ./src/app/masters/Complaints-types/complaints-type-form/complaints-type-form.component.ts